export enum ElixirType {
  SPEED = "speed",
  ENDURANCE = "stamina",
  LUCK = "luck"
}

export enum ElixirModel {
  REGULAR = "Elixir",
  PREMIUM = "PremiumElixir",
  DARK = "DarkElixir"
}
